













































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Ref, Watch } from 'vue-property-decorator';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  GridIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { FivGoalsFilter } from 'admiral-core';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import { PreferencesAction } from '@/store/PreferencesModule';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import BusinessYearFilter from '@/components/filters/BusinessYearFilter.vue';
import { BDropdown } from 'bootstrap-vue';
import { Util } from '@/utils/Util';

@Component({
  name: 'fiv-goals-filter',
  components: {
    BusinessYearFilter,
    TagSelect,
    HorizontalPolicyStatusSelect,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    UserIcon,
    XIcon,
    GridIcon,
  },
})
export default class FivGoalsFilterComponent extends mixins(FilterMixin) {
  filter: FivGoalsFilter = {
    year: new Date().getFullYear(),
  };
  @Ref('dropdown') dropdown!: BDropdown;

  get isDefaultFilter() {
    return false; // this.filter.year === new Date().getFullYear();
  }

  updateYearFilter(year: number) {
    this.filter.year = year;
    this.updateFilter();
  }

  resetFilter() {
    this.filter = {
      year: new Date().getFullYear(),
    };
    this.updateFilter();
    this.$root.$emit('reset-fiv-goals-filter');
  }

  get fivGoalsFilter(): FivGoalsFilter {
    return this.$store.getters['PreferencesModule/getFivGoalsFilter'];
  }

  @Watch('fivGoalsFilter')
  async onFilterChanged(filter: FivGoalsFilter) {
    this.filter = filter;
  }

  async mounted() {
    try {
      this.filter = await this.$store.getters['PreferencesModule/getFivGoalsFilter'];
    } catch (e) {
      this.$toastr.e('Beim Abrufen der Produkte und Mitarbeiter ist etwas schiefgelaufen.');
    }

    this.$root.$on('update-fiv-goals-filter', async () => {
      await this.updateFilter();
    });
  }

  async updateFilter() {
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.setFivGoalsFilter}`,
      this.filter,
    );

    // workaround
    this.$root.$emit('change-fiv-goals-filter');

    this.dropdown.hide();
  }

  selectedFilterString() {
    let str = '';
    str += 'Geschäftsjahr ' + this.filter.year;
    return str;
  }

  onOver() {
    (this.$refs as any).dropdown.visible = true;
  }
  onLeave(evt: Event) {
    (this.$refs as any).dropdown.visible = false;
  }

  get isMobile() {
    return Util.isMobile();
  }
}
